import { render, staticRenderFns } from "./AddRetailer.vue?vue&type=template&id=74ea5618&"
import script from "./AddRetailer.vue?vue&type=script&lang=js&"
export * from "./AddRetailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports